import React, { Component } from 'react'
import { connect } from 'react-redux'

import { flagImage } from '../../redux/image'
import FlagImageModal from '../modals/FlagImageModal'
import Icon from '../Icon'

class ImageFlagButton extends Component {
  state = {
    showModal: false
  }
  openModal = () => {
    this.setState({
      showModal: true
    })
  }
  closeModal = () => {
    this.setState({
      showModal: false
    })
  }
  flagImage = options => {
    console.log(options)
    const { flagImage, id } = this.props
    return flagImage(id, options).then(this.closeModal)
  }
  render () {
    const { className } = this.props
    const { showModal } = this.state
    return (
      <span>
        <button
          className={className}
          onClick={this.openModal}>
          <Icon icon='flag' />
        </button>
        {showModal &&
          <FlagImageModal
            closeModal={this.closeModal}
            onSubmit={this.flagImage}
          />
        }
      </span>
    )
  }
}

const mapDispatchToProps = {
  flagImage
}

export default connect(null, mapDispatchToProps)(ImageFlagButton)



// WEBPACK FOOTER //
// ./src/components/image/ImageFlagButton.js